import authenticated from '@/router/routes/authenticated'
import anonymous from '@/router/routes/anonymous'
import documentPreview from '@/router/routes/documentPreview'
import unknownDomain from '@/router/routes/unknownDomain'

export default [
	...authenticated,
	...documentPreview,
	...anonymous,
	...unknownDomain,
	{
		path: '*',
		redirect: '/'
	}
]
